<template>
  <v-dialog v-model="visible" max-width="800px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Establecer Programa Universidad</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12">
              <v-select
                :items="universidades"
                v-model="universidadId"
                item-text="nombre"
                item-value="id"
                label="Universidad"
                outlined
                dense
                placeholder="Seleccione"
                hide-details
                clearable
                :disabled="!!item?.programaUniversidad"
                @change="obtenerProgramasUniversidades" />
            </v-col>

            <v-col cols="12">
              <vue-select
                class="style-chooser"
                v-model="programaUniversidadId"
                placeholder="Seleccione un Programa Universidad"
                :options="programasUniversidades"
                label="programaNombre"
                :reduce="(option) => option.id"
                :filterable="false"
                :append-to-body="true"
                :disabled="!universidadId || !!item?.programaUniversidad"
                :selectable="(option) => option.estado == estadosProgramasUniversidades.PENDIENTE"
                @search="busquedaProgramaUniversidad">
                <template #header>
                  <div>Programa Universidad (Buscar por Codigo o Nombre Programa)</div>
                </template>

                <template
                  #option="{ codigo, programaNombre, resolucionAprobacionUniversidad, sedeUniversidad, estado }">
                  <div style="margin-bottom: 0.25rem">
                    <span style="display: block; font-size: 1rem">{{ codigo }} - {{ programaNombre }}</span>
                    <small style="display: block">
                      <strong>Sede Univ. </strong>{{ sedeUniversidad.nombre }} <strong>Resolución </strong
                      >{{ resolucionAprobacionUniversidad }}
                    </small>
                    <small style="display: block"> <strong>Estado </strong>{{ estado.toUpperCase() }} </small>
                  </div>
                </template>
              </vue-select>

              <small v-for="error in errores.programaUniversidadId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando || item.estado == estadosSolicitudesInscripciones.APROBADA"
          :loading="enviando"
          @click.prevent="$refs.confirmacionRef.abrir()">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import establecerProgramaUniversidadMixin from '../mixins/establecer-programa-universidad.mixin';
import ProgramaService from '../services/programa.service';
import { concatenar, formatearErrores } from '../utils/funciones';

export default {
  name: 'ModalFormularioEstablecerProgramaUniversidad',
  mixins: [establecerProgramaUniversidadMixin],
  data() {
    return {
      confirmacion: {
        titulo: 'Establecer Programa Universidad',
        mensaje: /*html*/ `¿Está seguro de establecer el Programa Universidad? <br />
        También se aprobarán todas las solicitudes de inscripción pendientes para este programa. <br />
        Al aceptar, usted (<strong>${concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        )}</strong>) será el responsable de esta acción.
        `,
        realizandoAccion: false,
        fnAceptar: () => this.establecer(),
      },
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        sedeId: null,
        sede: null,
        gestion: null,
        nombreCompuesto: null,
        postgradoId: null,
        postgrado: null,
        programaUniversidadId: null,
        programaUniversidad: null,
        nombreCorto: null,
        version: null,
        grupo: null,
        universidadId: null,
        universidad: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        sedeId: data.sedeId,
        sede: data.sede,
        gestion: data.gestion,
        nombreCompuesto: data.nombreCompuesto,
        postgradoId: data.postgradoId,
        postgrado: data.postgrado,
        programaUniversidadId: data.programaUniversidadId,
        programaUniversidad: data.programaUniversidad,
        nombreCorto: data.nombreCorto,
        version: data.version,
        grupo: data.grupo,
        universidadId: data.universidadId,
        universidad: data.universidad,
      };
    },
    abrir(data = null) {
      this.item = this.generarObjetoFormEditar(data);
      this.universidadId = data?.universidadId;
      this.programaUniversidadId = data?.programaUniversidad?.id;
      this.obtenerUniversidades();
      this.obtenerProgramasUniversidades();
      this.visible = true;
    },
    async establecer() {
      this.enviando = true;

      try {
        await ProgramaService.update(this.item.id, {
          programaUniversidadId: this.programaUniversidadId,
          atendidoPorId: this.$store.state.DATA_USER.id,
          atendidoPor: concatenar(
            this.$store.state.DATA_USER.nombres,
            this.$store.state.DATA_USER.pri_apellido,
            this.$store.state.DATA_USER.seg_apellido,
          ),
        });

        this.$emit('actualizarListado');
        this.cerrar();
        this.$emit('cerrar');
        this.$notify({
          group: 'notifications',
          title: 'Establecimiento de Programa Universidad',
          text: 'Programa Universidad establecido correctamente',
          type: 'success',
        });
      } catch (error) {
        const errores = error?.response?.data?.errores;
        this.errores = errores;
        const erroresFormateados = formatearErrores(errores);

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Establecimiento de Programa Universidad',
          text: erroresFormateados,
          type: 'error',
        });
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>